// extracted by mini-css-extract-plugin
export default {"recos":"o2-z","productCardOverride":"p2-z","rowHasBadge":"q2-z"};